import React from 'react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import getStyles from './styles';

const terms = [
  {
    title: 'Scope of Work',
    content:
      'Applies only to standard 5-page websites, template-based design. Optional add-ons excluded.'
  },
  {
    title: 'Content Submission',
    content:
      'All content and credentials must be provided by Day 0; delays pause the 10-days countdown.'
  },
  {
    title: 'Delivery Timeline',
    content:
      'Guaranteed website publishing within 48 hours after content is received.'
  },
  {
    title: 'Refund Policy',
    content:
      'Full refund if we fail to deliver on time. Not applicable for dissatisfaction, delayed content, or optional features.'
  },
  {
    title: 'Client Responsibilities',
    content:
      'Provide timely feedback and ensure domain/hosting accounts are active.'
  },
  {
    title: 'Exclusions',
    content:
      'Advanced SEO, third-party integrations, e-commerce, and content writing not included.'
  },
  {
    title: 'Limitation of Liability',
    content:
      'Liability limited to the service fee paid; Amizhth not responsible for third-party downtime.'
  }
];

const TenDaysMVPTerms = () => {
  const styles = getStyles();

  return (
    <Box component="section" id="terms" sx={styles.section}>
      <Container maxWidth="xl" sx={styles.container}>
        {/* Header */}
        <Box sx={styles.header}>
          <Box sx={styles.iconWrapper}>
            <DescriptionIcon sx={styles.icon} />
          </Box>
          <Typography variant="h2" sx={styles.title}>
            Terms & Conditions Summary
          </Typography>
          <Typography variant="h3" sx={styles.subtitle}>
            Transparency is key. Here&apos;s what you need to know.
          </Typography>
        </Box>

        {/* Card */}
        <Card sx={styles.card}>
          <CardContent sx={styles.cardContent}>
            {terms.map((term, index) => (
              <Box
                key={index}
                sx={{
                  ...styles.termItem,
                  animationDelay: `${index * 0.05}s`
                }}
              >
                <Box sx={styles.termIndex}>{index + 1}</Box>
                <Box sx={styles.termContent}>
                  <Typography variant="h6" sx={styles.termTitle}>
                    {term.title}
                  </Typography>
                  <Typography variant="body2" sx={styles.termDescription}>
                    {term.content}
                  </Typography>
                </Box>
              </Box>
            ))}
          </CardContent>
        </Card>

        {/* Footer Note */}
        <Typography variant="body2" sx={styles.footerNote}>
          For complete terms and conditions, please contact our team. We&apos;re
          committed to transparency and fair business practices.
        </Typography>
      </Container>
    </Box>
  );
};

export default TenDaysMVPTerms;
